@if (loading) {
  <app-loader></app-loader>
}
@if (isMaintenanceMode) {
  <app-maintenance></app-maintenance>
}

@if (!isMaintenanceMode) {
  <router-outlet></router-outlet>
}
<div class="my-cursor"></div>
<div class="cursor-follower"></div>
